import { maxBy, minBy } from "lodash-es";
import { getMax, getMin } from "../Core/math";
export function calculateDomain(points) {
  var _minBy, _maxBy, _getMin, _getMax;
  const xs = points.map(p => p.x);
  const ys = points.map(p => p.y);
  const asNum = x => x instanceof Date ? x.getTime() : x;
  return {
    x: [(_minBy = minBy(xs, asNum)) !== null && _minBy !== void 0 ? _minBy : 0, (_maxBy = maxBy(xs, asNum)) !== null && _maxBy !== void 0 ? _maxBy : 0],
    y: [(_getMin = getMin(ys)) !== null && _getMin !== void 0 ? _getMin : 0, (_getMax = getMax(ys)) !== null && _getMax !== void 0 ? _getMax : 0]
  };
}
export function axesMatch(a1, a2) {
  // ignore unit label if both scales are time
  if (a1.scale === "time" && a2.scale === "time") return true;else return a1.scale === a2.scale && a1.units === a2.units;
}

/**
 * Describes a quantity that can be rendered on the chart along its y-axis.
 */

function ChartableMixin(Base) {
  class ChartableMixin extends Base {
    get hasChartableMixin() {
      return true;
    }
    get isChartable() {
      return true;
    }

    /**
     * Gets the items to show on a chart.
     */
  }
  return ChartableMixin;
}
(function (_ChartableMixin) {
  function isMixedInto(model) {
    return !!(model !== null && model !== void 0 && model.hasChartableMixin);
  }
  _ChartableMixin.isMixedInto = isMixedInto;
})(ChartableMixin || (ChartableMixin = {}));
export default ChartableMixin;